import React from 'react'
import { Col } from 'react-bootstrap'
import { StaticImage } from 'gatsby-plugin-image'
import PrimaryButton from '../buttons/Buttons'

const BannerAd = ({ banner, currentDropdown }) => {
  const heading = banner.heading
  const btnText = banner.btnText
  const uri = banner.uri
  const img = banner.img

  return (
    <Col className='dropdown-col position-relative'>
      <div className='overlay-text'>
        <h3 className='banner-heading'>{heading}</h3>
        <PrimaryButton
          url={uri}
          variant={'buy'}
          className={'banner-btn'}
          icon
          blank={false}
        >
          {btnText}
        </PrimaryButton>
      </div>

      {(() => {
        if (currentDropdown === 'collection') {
          let banner = (
            <StaticImage
              src='../../assets/images/banner-ads/collections.png'
              alt='collections banner ad'
              className='img-fluid banner-ad-img'
            />
          )

          return banner
        }
        if (currentDropdown === 'category') {
          let banner = (
            <StaticImage
              src='../../assets/images/banner-ads/collections.png'
              alt='collections banner ad'
              className='img-fluid banner-ad-img'
            />
          )

          return banner
        }
        if (currentDropdown === 'education') {
          return (
            <StaticImage
              src='../../assets/images/banner-ads/education.png'
              alt='education banner ad'
              className='img-fluid banner-ad-img'
            />
          )
        }

        if (currentDropdown === 'deals') {
          return (
            <StaticImage
              src={'../../assets/images/banner-ads/deals.png'}
              alt='deals banner ad'
              className='img-fluid banner-ad-img'
            />
          )
        }
      })()}
    </Col>
  )
}

export default BannerAd
